'use client';
import { useEffect, useRef } from 'react';

import annalsGrid from '~features/annals/hooks/grid';
import { useSession } from '~hooks/useSession';

type Props = {
	exposed: boolean;
	page?: string;
};

export const GridAnnals = ({ exposed, page }: Props) => {
	const { isSuccess } = useSession();
	const currentPage = exposed ? Number(page) || 1 : undefined;
	const prevCurrentPage = useRef(currentPage);
	const hasTrackedOnce = useRef(false);
	const sendViewed = annalsGrid.useGridViewed({ page: currentPage });

	useEffect(() => {
		if (prevCurrentPage.current !== currentPage) {
			prevCurrentPage.current = currentPage;
			hasTrackedOnce.current = false;
		}

		if (isSuccess && !hasTrackedOnce.current) {
			hasTrackedOnce.current = true;
			void sendViewed();
		}
		// eslint-disable-next-line
	}, [isSuccess, currentPage]);

	return null;
};
